import * as z from "zod";

const SchemaSalidaBase = z.object({
	id: z.uuid(),
	nombre: z.string().min(1, "El nombre es obligatorio"),
	tipo: z.literal("salida"),
	subtipo: z.enum(["raw_co2", "producto", "main_producto", "residuo"]),
	cantidad: z.coerce
		.number<string | number>("La cantidad es obligatoria")
		.positive("La cantidad debe ser mayor que 0"),
	idProyecto: z.uuid(),
	idProcesoFrom: z.uuid().nullable(),
});

export const SchemaRawCO2 = SchemaSalidaBase.extend({
	subtipo: z.literal("raw_co2"),
	unidad: z.literal("g"),
});
export type SchemaRawCO2In = z.input<typeof SchemaRawCO2>;
export type SchemaRawCO2 = z.infer<typeof SchemaRawCO2>;

export const SchemaProducto = SchemaSalidaBase.extend({
	subtipo: z.enum(["producto", "main_producto"]),
	unidad: z.string().min(1, "La unidad es obligatoria"),
});
export type SchemaProductoIn = z.input<typeof SchemaProducto>;
export type SchemaProducto = z.infer<typeof SchemaProducto>;

export const SchemaResiduo = SchemaSalidaBase.extend({
	subtipo: z.literal("residuo"),
	unidad: z.string().min(1, "La unidad es obligatoria"),
	equalCO2: z.coerce.number<string | number>().min(1, "El CO2 por unidad es obligatorio"),
});
export type SchemaResiduoIn = z.input<typeof SchemaResiduo>;
export type SchemaResiduo = z.infer<typeof SchemaResiduo>;